import { Navigate } from 'react-router-dom';
import { useBeta } from '../../context/BetaContext';
import AppLoader from '../ui/AppLoader';

/**
 * Neutralise une route marketing pendant la beta.
 *
 * La lecture de BETA_ENABLED est asynchrone. Trois etats :
 *  - chargement  : on affiche le loader de l'application, uniquement sur cette
 *                  route. Rien du contenu marketing n'est rendu, donc pas
 *                  d'eclair de tarifs, et le reste de l'app n'est pas bloque.
 *  - beta active : redirection vers l'accueil (l'URL tapee directement est
 *                  neutralisee, pas seulement le lien masque).
 *  - beta finie  : la page s'affiche normalement.
 */
const BetaRestrictedRoute = ({ children, redirectTo = '/' }) => {
    const { betaEnabled, betaLoading } = useBeta();

    if (betaLoading) {
        return <AppLoader />;
    }

    if (betaEnabled) {
        return <Navigate to={redirectTo} replace />;
    }

    return children;
};

export default BetaRestrictedRoute;
